import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Heading from '../../../../../generic-components/Heading';
import Button from '../../../../../generic-components/Button';
import { FORGOT_PASSWORD_FLOW, GENERAL_STYLE } from '../constants';
import { UserMessage } from '../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { ReactComponent as ErrorIcon } from '../../../../../assets/icons/svg/stamp-icons/ic-stamp-alert-triangle.svg';
import { VIEWS_MAP } from '../../../../../router/constants';
import { CloseButton, CloseButtonSize } from '../../../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps{
    title: string
    description: string
    mainButtonTitle?: string
    onAction: () => void
    onClose: () => void
    icon?: ReactElement
    hideSecondaryButton?: boolean
}
export const ForgotPasswordGeneralErrorModal = ({
  title, description, onAction, onClose, icon, mainButtonTitle, hideSecondaryButton,
}: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <UserMessage onClick={onClose} id=''>
      <div className={`${GENERAL_STYLE.LOGIN_CARD.CLASS_NAME} flex flex-col items-center`}>
        <CloseButton onClick={onClose} className='absolute right-0 my-[-30px] mx-[10px]' id='closeButton' size={CloseButtonSize.Large} />
        {icon || <ErrorIcon />}
        <Heading title={title} className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[16px] text-center mt-[20px]`} />
        <div className='flex flex-col items-center'>

          <Heading title={description} className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} mb-[36px] text-center`} />
          <Button className={`${GENERAL_STYLE.MAIN_BUTTON.CLASS_NAME}`} id='error_main_button' title={mainButtonTitle || t(FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_MAIN_ACTION_TITLE)} onClick={onAction} testId='error_main_button' />
          {!hideSecondaryButton && (
          <Button
            className={`${GENERAL_STYLE.SECONDARY_BUTTON.CLASS_NAME} mt-[24px]`}
            id='error_secondary_button'
            title={t(FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_SECONDARY_ACTION_TITLE)}
            onClick={() => {
              navigate(`/${VIEWS_MAP.RECOVERY}`);
            }}
            testId='error_secondary_button'
          />
          )}

        </div>
      </div>
    </UserMessage>
  );
};
